let AuthInterceptor = function($state, authService) {
  return {
    request: function(request) {
      let token = authService.getAccessToken();

      if (token) {
        request.headers = request.headers || {};
        request.headers.Authorization = 'Bearer ' + token;
      }

      return request;
    },
    responseError: function(error) {
      switch(error.status) {
      case 403:
        return $state.go('403', {}, { location: false });
      case 401:
        return authService.forceLogin();
      default:
        throw error;
      }
    }
  };
};

AuthInterceptor.$inject = [ '$state', 'authService' ];

export default AuthInterceptor;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/journey-ui/auth/services/auth.interceptor.js